import AdviceLandingPage from "@dogstrust/uk/staticPageTemplates/AdviceLandingPage/AdviceLandingPage";
export { Head } from "@dogstrust/uk/staticPageTemplates/AdviceLandingPage/AdviceLandingPage";

import { graphql } from "gatsby";
import React from "react";

export interface DogIndexPageProps {
	data: Queries.AdvicePageQuery;
}

const AdvicePage: React.FC<DogIndexPageProps> = ({ data }) => (
	<AdviceLandingPage data={data} />
);

export default AdvicePage;

export const query = graphql`
    query AdvicePage {
        helpAdviceTopics: allNodeTopic(
            filter: { relationships: { field_parent: { name: { eq: "Dog advice" } } } }
            sort: { field_priority_weight: ASC }
        ) {
            nodes {
                ...Topic
            }
        }
        helpAdviceChildLandingPages: allNodeLandingPage(
            filter: {
                relationships: { field_category_type: { name: { eq: "Dog advice" } } }
            }
            sort: { field_priority_weight: ASC }
        ) {
            nodes {
                ...LandingPageSignPostData
            }
        }
        newsletterPromo: nodeSection(title: { eq: "Section-Newsletter-Promo" }) {
            field_front_end_title
            field_link {
                title
                uri
            }
            field_section_short_description {
                value
            }
        }
        suggestedArticles: nodeSection(
        title: { eq: "Section-Advice-Suggested-Articles" }
        ) {
            ...SectionData
        }
        pageData: nodeStaticInternalPageReference(
        field_link: { uri: { eq: "/dog-advice" } }
        ) {
            ...StaticPageData
        }
    }
`;
